<div class="container-fluid py-4">
    <!-- Header del reporte -->
    <div class="row align-items-center mb-4">
        <div class="col-md-4 text-center text-md-start">
            <img class="logo img-fluid" src="./assets/img/logo.jpeg" alt="Logo Uturunco Studio"
                style="max-height: 80px;">
            <div class="mt-2">
                <h5 class="mb-0 fw-bold">Uturunco Studio</h5>
                <small class="text-muted">Empresa independiente de desarrollo de software</small>
            </div>
        </div>

        <div class="col-md-4 text-center">
            <h3 class="mb-1 fw-bold text-primary">Reporte de Total Ventas</h3>
            <h6 class="text-muted">App Control Stock — Ventas y Ganancia por usuario</h6>
        </div>

        <div class="col-md-4 text-center text-md-end">
            <small class="text-muted">
                Resistencia, Chaco<br>
                {{ fecha | date:'dd MM yyyy' }}
            </small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-4">
        <div class="card-body">
            <div class="row g-3 align-items-end">
                <!-- Checkbox usar fecha 
                <div class="col-md-2">
                    <div class="form-check mt-4">
                        <input type="checkbox" class="form-check-input" id="useFecha" [(ngModel)]="useFecha"
                            name="useFecha">
                        <label class="form-check-label" for="useFecha">
                            Usar rango de fechas
                        </label>
                    </div>
                </div>
                -->

                <!-- Fecha desde -->
                <div class="col-md-3">
                    <label class="form-label fw-bold">Fecha desde</label>
                    <input type="date" class="form-control" id="fechade" [value]="fechade | date:'yyyy-MM-dd'"
                        (input)="fechade = parseDate($event.target.value)" [disabled]="!useFecha" required />
                </div>

                <!-- Fecha hasta -->
                <div class="col-md-3">
                    <label class="form-label fw-bold">Fecha hasta</label>
                    <input type="date" class="form-control" id="fechaha" [value]="fechaha | date:'yyyy-MM-dd'"
                        (input)="fechaha = parseDate($event.target.value)" [disabled]="!useFecha" required />
                </div>

                <!-- Botón buscar + Excel -->
                <div class="col-md-4 d-flex gap-2 align-items-end">
                    <button class="btn btn-primary flex-grow-1" (click)="getList()"
                        [disabled]="useFecha && (!fechade || !fechaha)">
                        <i class="fas fa-search me-2"></i> Consultar
                    </button>
                    <button type="button" (click)="exportTableToExcel('tblData','ventas')"
                        class="btn btn-outline-success">
                        <i class="fas fa-file-excel me-2"></i> Excel
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Resultados -->
    <div class="card shadow-sm">
        <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Resumen de ventas y ganancias</h5>
            <small class="text-muted" *ngIf="items || ganancia">
                Período:
                <strong>{{ fechade | date:'dd-MM-yy' }} → {{ fechaha | date:'dd-MM-yy' }}</strong>
            </small>
        </div>

        <div class="card-body p-0">
            <!-- Loading (agrega tu variable loading si la implementaste) -->
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-3 text-muted">Obteniendo totales de ventas y ganancias...</p>
            </div>

            <div *ngIf="!loading">
                <div class="table-responsive">
                    <table id="tblData" class="table table-hover table-bordered mb-0">
                        <thead class="table-dark">
                            <tr>
                                <th>Tipo</th>
                                <th>Usuario</th>
                                <th class="text-end">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Ventas por usuario -->
                            <tr *ngFor="let entry of items | keyvalue">
                                <td>Ventas</td>
                                <td>{{ entry.key }}</td>
                                <td class="text-end fw-bold text-success">
                                    {{ entry.value | currency:'$ ' }}
                                </td>
                            </tr>

                            <!-- Ganancia por usuario -->
                            <tr *ngFor="let entry of ganancia | keyvalue">
                                <td>Ganancia</td>
                                <td>{{ entry.key }}</td>
                                <td class="text-end fw-bold text-primary">
                                    {{ entry.value | currency:'$ ' }}
                                </td>
                            </tr>

                            <!-- Mensaje sin datos -->
                            <tr *ngIf="!(items | keyvalue)?.length && !(ganancia | keyvalue)?.length">
                                <td colspan="3" class="text-center text-muted py-4">
                                    <i class="fas fa-info-circle fa-2x mb-2"></i><br>
                                    No hay datos para el período seleccionado.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Resumen rápido (opcional) -->
                <div class="p-3 bg-light border-top" *ngIf="items || ganancia">
                    <div class="row text-center">
                        <div class="col-md-6">
                            <small class="text-muted d-block">Total Ventas</small>
                            <h5 class="text-success mb-0">
                                {{ totalVentas }}
                            </h5>
                        </div>
                        <div class="col-md-6">
                            <small class="text-muted d-block">Total Ganancia</small>
                            <h5 class="text-primary mb-0">
                                {{ totalGanancia }}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer text-end bg-light" *ngIf="!loading">
            <small class="text-muted">
                Generado el {{ fecha | date:'dd-MM-yyyy HH:mm' }}
            </small>
        </div>
    </div>
</div>